<template>
    <div class="mainpage">
        <div class="d-flex justify-content-end mb-3">
            <Calendar ref="searchCalendar" @date-select="dateSearch" class="gap" v-model="date" showIcon :maxDate="maxDate"  selectionMode="range" :manualInput="false" placeholder="Last 30 days"/>
        </div>
        <div class="d-flex justify-content-start flex-wrap row-1">
            <div class="metric-cards d-flex justify-content-between flex-wrap">
                <div class="whitelist-metric metric-card">
                    <p class="m-0"> Total URLs </p>
                    <p class="mb-1"> Whitelisted </p>
                    <Skeleton v-if="whitelistLoader" size="50%" shape="circle"/>
                    <div v-tooltip="getCardsData.whitelistedUrls" v-else class="card-count">
                        {{ this.millify(getCardsData.whitelistedUrls) }}
                    </div>
                </div>
                <div class="short-metric metric-card">
                    <p class="m-0"> Total URLs </p>
                    <p class="mb-1"> Shortened </p>
                    <Skeleton v-if="whitelistLoader" size="50%" shape="circle"/>
                    <div v-tooltip="getCardsData.shortenedUrls" v-else class="card-count">
                        {{ this.millify(getCardsData.shortenedUrls) }}
                    </div>
                </div>
                <div class="domain-metric metric-card">
                    <p class="m-0"> URLs shortened using </p>
                    <p class="mb-1"> Branded domain </p>
                    <Skeleton v-if="whitelistLoader" size="50%" shape="circle"/>
                    <div v-else class="card-count">
                        0
                    </div>
                </div>
                <div class="subdom-metric metric-card">
                    <p class="m-0"> URLs shortened by using</p>
                    <p class="mb-1"> Custom back halves </p>
                    <Skeleton v-if="whitelistLoader" size="50%" shape="circle"/>
                    <div v-else class="card-count">
                        0
                    </div>
                </div>
            </div>
            <div class="graph-container">
                <div class="type-graph gap2">
                    <Skeleton v-if="whitelistLoader" shape="circle" size="50%"></Skeleton>
                    <ECharts v-else :chartOptions="getCtaTypeMetrics" />
                </div>
                <div class="type-graph">
                    <Skeleton v-if="clickLoader" shape="circle" size="50%"></Skeleton>
                    <ECharts v-else :chartOptions="getClickmetrics" />
                </div>
            </div>
        </div>
        <div class="row-2 graphs">
            <div class="graph-heading">
                Click Trend
            </div>
            <Skeleton v-if="trendLoader" class="card-skeleton"></Skeleton>
            <div v-else class="card-skeleton">
                <ECharts :chartOptions="getClickTrend" />
            </div>
        </div>
        <div class="row-2 graphs">
            <div class="graph-heading">
                Top 5 links with clicks
            </div>
            <Skeleton v-if="linkLoader" class="card-skeleton"></Skeleton>
            <div v-else class="card-skeleton">
                <ECharts :chartOptions="getLinkClicks" />
            </div>
        </div>
        <div class="d-flex justify-content-between flex-wrap row-3">
            <div class="type-graph-all">
                <div class="graph-top-bar">
                    <div class="graph-heading">
                        Geographic Click Distribution
                    </div>
                    <div class="toggle-graph">
                        <SelectButton @change="fetchDemographicAnalytics" v-model="demoType" :options="demoOptions" optionLabel="name" optionValue="value" aria-labelledby="basic" />
                    </div>
                </div>
                <div v-if="demoLoader" class="d-flex justify-content-center align-items-center skeleton-box">
                    <Skeleton shape="circle" size="15rem"></Skeleton>
                    <div>
                        <Skeleton  :key="n" v-for="n in 6" class="skeleton-line-spacing"></Skeleton>
                    </div>
                </div>
                <div v-else-if="getEmptyState.demograph" class="d-flex justify-content-center align-items-center empty-graph">
                    No data available
                </div>
                <ECharts v-else :chartOptions="getDemographicClicks" />
            </div>
            <div class="type-graph-all">
                <div class="graph-top-bar">
                    <div class="graph-heading mb-4">
                        Telco Click Distribution
                    </div>
                </div>
                <div v-if="telcoLoader" class="d-flex justify-content-center align-items-center skeleton-box">
                    <Skeleton shape="circle" size="15rem"></Skeleton>
                    <div>
                        <Skeleton :key="n" v-for="n in 6" class="skeleton-line-spacing"></Skeleton>
                    </div>
                </div>
                <div v-else-if="getEmptyState.telco" class="d-flex justify-content-center align-items-center empty-graph">
                    No data available
                </div>
                <ECharts v-else :chartOptions="getTelcoClicks" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import ECharts from '@/components/common/ECharts.vue'
import SelectButton from 'primevue/selectbutton'
import moment from 'moment'
import millify from 'millify'

export default {
    name: 'Analytics',
    components: {
        ECharts, SelectButton
    },
    data () {
        return {
            maxDate: null,
            date: [],
            startDay: '',
            endDay: '',
            demoLoader: false,
            browserLoader: false,
            telcoLoader: false,
            deviceLoader: false,
            whitelistLoader: false,
            clickLoader: false,
            trendLoader: false,
            linkLoader: false,
            demoType: 'city',
            demoOptions: [{ name: 'City', value: 'city' }, { name: 'State', value: 'state' }, { name: 'Country', value: 'country' }],
            browserType: 'browser',
            browserOptions: [{ name: 'Browser', value: 'browser' }, { name: 'OS', value: 'os' }],
            deviceType: 'device',
            deviceOptions: [{ name: 'Device', value: 'device' }, { name: 'Device make', value: 'make' }]
        }
    },
    methods: {
        millify,
        async dateSearch () {
            if (this.date[1] != null) {
                this.$refs.searchCalendar.overlayVisible = false
                this.demoType = 'city'
                this.browserType = 'browser'
                this.deviceType = 'device'
                this.fetchTelcoAnalytics()
                this.fetchDeviceAnalytics()
                this.fetchBrowserAnalytics()
                this.fetchClicksAnalytics()
                this.fetchClickTrendAnalytics()
                this.fetchDemographicAnalytics()
                this.fetchLinkAnalytics()
                this.fetchShortenedAnalytics()
                this.fetchWhitelistAnalytics()
            }
        },
        async fetchWhitelistAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            this.whitelistLoader = true
            await this.$store.dispatch('Dashboards/Analytics/fetchWhitelistAnalytics', data)
            this.whitelistLoader = false
        },
        async fetchShortenedAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            await this.$store.dispatch('Dashboards/Analytics/fetchShortenedAnalytics', data)
        },
        async fetchClicksAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            this.clickLoader = true
            await this.$store.dispatch('Dashboards/Analytics/fetchClicksAnalytics', data)
            this.clickLoader = false
        },
        async fetchClickTrendAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            this.trendLoader = true
            await this.$store.dispatch('Dashboards/Analytics/fetchClickTrendAnalytics', data)
            this.trendLoader = false
        },
        async fetchLinkAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            this.linkLoader = true
            await this.$store.dispatch('Dashboards/Analytics/fetchLinkAnalytics', data)
            this.linkLoader = false
        },
        async fetchDemographicAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay,
                type: this.demoType
            }
            this.demoLoader = true
            await this.$store.dispatch('Dashboards/Analytics/fetchTypeAnalytics', data)
            this.demoLoader = false
        },
        async fetchTelcoAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay,
                type: 'telco'
            }
            this.telcoLoader = true
            await this.$store.dispatch('Dashboards/Analytics/fetchTypeAnalytics', data)
            this.telcoLoader = false
        },
        async fetchBrowserAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay,
                type: this.browserType
            }
            this.browserLoader = true
            await this.$store.dispatch('Dashboards/Analytics/fetchTypeAnalytics', data)
            this.browserLoader = false
        },
        async fetchDeviceAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay,
                type: this.deviceType
            }
            this.deviceLoader = true
            await this.$store.dispatch('Dashboards/Analytics/fetchTypeAnalytics', data)
            this.deviceLoader = false
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapGetters('Dashboards/Analytics',
            [
                'getCtaTypeMetrics',
                'getClickmetrics',
                'getClickTrend',
                'getCitiesClicks',
                'getLinkClicks',
                'getCardsData',
                'getDemographicClicks',
                'getTelcoClicks',
                'getDeviceClicks',
                'getBrowserClicks',
                'getEmptyState'
            ])
    },
    async mounted () {
        this.maxDate = new Date()
        this.fetchTelcoAnalytics()
        this.fetchDeviceAnalytics()
        this.fetchBrowserAnalytics()
        this.fetchClicksAnalytics()
        this.fetchClickTrendAnalytics()
        this.fetchDemographicAnalytics()
        this.fetchLinkAnalytics()
        this.fetchShortenedAnalytics()
        this.fetchWhitelistAnalytics()
    }
}
</script>

<style>
.card-skeleton {
    width: 100%;
    height: calc(100% - 2rem) !important;
}
.type-graph {
    display: flex;
    align-items: center;
    justify-content:center;
    border: 1px solid #ced4da;
    color: #495057;
    background-color: white;
    border-radius: 10px;
    width: 50%;
}
.type-graph-all {
    border: 1px solid #ced4da;
    color: #495057;
    background-color: white;
    border-radius: 10px;
    width: calc(50% - 0.5rem);
    height: 350px;
    padding: 1rem;
}
.skeleton-box {
    height: 100%;
    width: 100%;
}
.skeleton-line-spacing {
    margin-left: 2rem;
    height: 0.7rem !important;
    width: 10rem !important;
    margin-bottom: 0.5rem;
}
.graph-top-bar {
    display: flex;
    justify-content: space-between;
}
.graph-heading {
    color: #495057;
    font-weight: 700;
    font-size: 1rem;
}
.empty-graph {
    height: 90%;
    color: #495057;
    font-weight: 700;
    font-size: 1rem;
}
.row-3 {
    row-gap: 1rem;
    margin-bottom: 1rem;
}
.gap2 {
    margin-right: 1rem;
}
.metric-cards {
    row-gap: 1rem;
}
.graph-container {
    flex: 1;
    display: flex;
    width: 60%;
}
.row-1 {
    row-gap: 1rem;
    margin-bottom: 1rem;
}
.row-2 {
    padding: 1rem;
    min-width: 900px;
    margin-bottom: 1rem;
    border-radius: 10px;
}
.graphs {
    border: 1px solid #ced4da;
    color: #495057;
    background-color: white;
}
.card-count {
    height: 50%;
    width: 50%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 2rem;
    font-weight: 700;
}
.metric-card {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    font-weight: 700;
    font-size: .8125rem;
    border: 1px solid #ced4da;
    color: #495057;
    background-color: white;
    margin-right: 1rem;
}
.card-count {
    background-color: white;
    border: 2px solid var(--primary-color);
    color: #495057;
}
@media screen and (min-width: 1800px) {
    .metric-cards {
        width: calc(500px + 2rem);
    }
    .metric-card {
        height: 250px;
        width: 250px;
    }
    .type-graph {
        height: calc(500px + 1rem);
    }
    .row-2 {
        height: 500px;
    }
}
@media screen and (max-width: 1800px) {
    .metric-cards {
        width: calc(400px + 2rem);
    }
    .metric-card {
        height: 200px;
        width: 200px;
    }
    .type-graph {
        height: calc(400px + 1rem);
    }
    .row-2 {
        height: 400px;
    }
}
@media screen and (max-width: 1500px) {
    .metric-cards {
        width: calc(300px + 2rem);
    }
    .metric-card {
        height: 150px;
        width: 150px;
    }
    .type-graph {
        height: calc(300px + 1rem);
    }
    .row-2 {
        height: 300px;
    }
}
@media screen and (max-width: 1200px) {
    .metric-cards {
        width: 100%;
    }
    .type-graph {
        height: calc(350px + 1rem);
    }
    .metric-card {
        height: 150px;
        width: 150px;
    }
    .row-2 {
        height: 350px;
    }
}

@media screen and (max-width: 761px) {
    .metric-cards {
        width: 100%;
    }
    .type-graph {
        height: calc(350px + 1rem);
    }
    .metric-card {
        height: 150px;
        width: 150px;
    }
    .row-2 {
        height: 350px;
    }
}
@media screen and (max-width: 1140px) {
    .row-2 {
        min-width: 700px;
    }
}
</style>
